// extracted by mini-css-extract-plugin
export default {"root":"odpcI","closed":"kYUOq","navigation":"O9wzK"};